import { toast } from "react-toastify";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_IMAGE_EXTENSIONS,
  MAX_FILE_SIZE,
} from "../constants";

export type UploadType = keyof typeof MAX_FILE_SIZE;

export const handleFileChange = async (
  e: React.ChangeEvent<HTMLInputElement>,
  type: UploadType,
  uploadFile: (
    file: File,
    type: UploadType,
    callback: (file: File) => Promise<void>,
  ) => Promise<void>,
  handlePhotoUpload: (file: File) => Promise<void>,
  handleFileUpload: (file: File, type: "file") => Promise<void>,
): Promise<void> => {
  const file = e.target.files?.[0];
  if (!file) return;

  const extension = file.name.split(".").pop()?.toLowerCase();
  const fileSizeInMB = file.size / (1024 * 1024);
  const maxFileSize = MAX_FILE_SIZE[type];

  if (fileSizeInMB > maxFileSize) {
    toast.error(
      `File size is too large. Maximum allowed size for ${type}s is ${maxFileSize} MB.`,
    );
    e.target.value = "";
    return;
  }

  let isValidFile = false;
  if (type === "image" && ALLOWED_IMAGE_EXTENSIONS.includes(extension || "")) {
    isValidFile = true;
  } else if (
    type === "file" &&
    ALLOWED_FILE_EXTENSIONS.includes(extension || "")
  ) {
    isValidFile = true;
  }

  if (!isValidFile) {
    toast.error(
      `Invalid file type. Please upload ${
        type === "image" ? "an image" : "a document"
      } with correct format.`,
    );
    e.target.value = "";
    return;
  }

  try {
    if (type === "image") {
      await uploadFile(file, type, (file) => handlePhotoUpload(file));
    } else if (type === "file") {
      await uploadFile(file, type, (file) => handleFileUpload(file, "file"));
    }
  } catch (error) {
    e.target.value = "";
  }

  e.target.value = "";
};
